export default {"src":"/_next/static/media/leaf-bg-2.8cddd2e9.svg","height":40,"width":40};